/* eslint-disable no-case-declarations */
import * as apiKeyActions from '../actions/apiKey';

const defaultState = {
  apiKeys: [],
  loading: false,
  error: null,
};

// eslint-disable-next-line default-param-last
const apiKey = (state = defaultState, action) => {
  switch (action.type) {
    case apiKeyActions.GET_API_KEYS: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case apiKeyActions.GET_API_KEYS_SUCCESS:
      return {
        ...state,
        apiKeys: action.payload,
        loading: false,
        error: null,
      };
    case apiKeyActions.ADD_API_KEY_SUCCESS:
      return {
        ...state,
        apiKeys: [...state.apiKeys, action.payload],
        loading: false,
        error: null,
      };
    case apiKeyActions.DELETE_API_KEY_SUCCESS:
      return {
        ...state,
        apiKeys: state.apiKeys.filter((key) => key.value !== action.payload.value),
        loading: false,
        error: null,
      };
    case apiKeyActions.GET_API_KEYS_ERROR:
    case apiKeyActions.ADD_API_KEY_ERROR:
    case apiKeyActions.DELETE_API_KEY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default apiKey;
